import { ParsedUrlQuery } from 'querystring'

export function getFirstQueryParam(param: ParsedUrlQuery[keyof ParsedUrlQuery]): string {
  const queryParam = Array.isArray(param) ? param : [param]
  return queryParam[0] || ''
}
